import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 133px;
  z-index: 1;
  display: flex;
  font-weight: 700;
  color: #333;
  align-items: center;

  svg {
    color: #888;
    font-size: 0.8em;
    cursor: pointer;

    &:hover {
      color: #402680;
    }
  }

  ${mediaMaxWidth.smallDesktop} {
    display: none;
  }
`;

export const Counter = styled.div`
  color: #79D9D9;
  margin: 0 5px;
`;
